// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1":"fecc3446","193":"d58fe10b","470":"0fe7c20a"}[chunkId] + ".chunk.css";
};